import api from '../utils/api'
import { toast } from 'react-toastify'
import {
  GET_PROFILE_TEACHER,
  PROFILE_TEACHER_ERROR,
  GET_PROFILE_TEACHER_ERROR,
  CLEAR_PROFILE_TEACHER,
  GET_PROFILE_TEACHER_BY_ID_SUCCESS,
  GET_PROFILE_TEACHER_BY_ID_ERROR,
  ACCOUNT_DELETED,
  FETCH_ALL_TEACHERS,
  START_LOADING,
  END_LOADING,
  FETCH_TEACHERS_BY_SEARCH,
  FETCH_TEACHERS_BY_SEARCH_FAIL,
  SET_UPLOADING_TRUE,
  SET_UPLOADING_FALSE
} from './types'
import axios from 'axios'

// Get current teachers profile
export const getCurrentProfileTeacher = () => async (dispatch) => {
  try {
    const res = await api.get('/profileTeacher/me')

    dispatch({
      type: GET_PROFILE_TEACHER,
      payload: res.data,
    })
  } catch (err) {
    dispatch({
      type: GET_PROFILE_TEACHER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Create or update profile
export const createOrUpdateProfileTeacher =
  (data, history, edit = false) =>
    async (dispatch) => {
      const {
        degreeImages,
        selectedDegreeImages,
        expImages,
        selectedExpImages,
        typeOfTeacher,
        thumbnail,
        video,
        selectedVideo,
        hometown,
        lessons,
        teacherAvatar,
        selectedTeacherAvatar,
        phoneNumber,
        dateOfBirth,
        introduction,
        skypeId,
        cardNumber,
        nameOnCard,
        bankName,
      } = data
   
      try {
        dispatch({
          type: SET_UPLOADING_TRUE,
        })

        let newTeacherAvatar
        if (selectedTeacherAvatar) {
          const formData = new FormData()
          formData.append('file', selectedTeacherAvatar)
          formData.append('upload_preset', 'teacherAvatar')

          const res = await axios.post(
            'https://api.cloudinary.com/v1_1/youspeak/image/upload',
            formData
          )

          newTeacherAvatar = res.data.public_id
        }

        let newDegreeImages = []
        if (selectedDegreeImages.length) {

          for (let i = 0; i < selectedDegreeImages.length; i++) {
            const formData = new FormData()

            formData.append('file', selectedDegreeImages[i])
            formData.append('upload_preset', 'degreeImages')

            const res = await axios.post(
              'https://api.cloudinary.com/v1_1/youspeak/image/upload',
              formData
            )

            const resDegreeImage = res.data.public_id

            newDegreeImages.push(resDegreeImage)
          }
        }

        let newExpImages = []
        if (selectedExpImages.length > 0) {

          for (let i = 0; i < selectedExpImages.length; i++) {
            const formData = new FormData()

            formData.append('file', selectedExpImages[i])
            formData.append('upload_preset', 'expImages')

            const res = await axios.post(
              'https://api.cloudinary.com/v1_1/youspeak/image/upload',
              formData
            )

            const resExpImage = await res.data.public_id

            newExpImages.push(resExpImage)
          }
        }

        let newVideo
        if (selectedVideo) {
          const formData = new FormData()
          formData.append('file', selectedVideo)
          formData.append('upload_preset', 'teacherIntroductionVideo')

          const res = await axios.post(
            'https://api.cloudinary.com/v1_1/youspeak/video/upload',
            formData
          )

          newVideo = await res.data.public_id
        }

        const newData = {
          typeOfTeacher,
          thumbnail,
          video,
          selectedVideo: newVideo,
          hometown,
          lessons,
          teacherAvatar,
          selectedTeacherAvatar: newTeacherAvatar,
          phoneNumber,
          dateOfBirth,
          introduction,
          skypeId,
          cardNumber,
          nameOnCard,
          bankName,
          degreeImages,
          selectedDegreeImages: newDegreeImages,
          expImages,
          selectedExpImages: newExpImages
        }

        const res = await api.post('/profileTeacher', newData)

        dispatch({
          type: GET_PROFILE_TEACHER,
          payload: res.data,
        })

        dispatch({ type: SET_UPLOADING_FALSE })

        toast.success(
          edit
            ? 'Your profile has been updated successfully!'
            : 'Your profile has been created!'
        )

        history.push('/teachers/dashboard')
      } catch (err) {
        dispatch({
          type: PROFILE_TEACHER_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        })
      }
    }

// Delete account & profile
export const deleteAccount = () => async (dispatch) => {
  if (window.confirm('Are you sure? This can NOT be undone!')) {
    try {
      await api.delete('/profile')

      dispatch({ type: CLEAR_PROFILE_TEACHER })
      dispatch({ type: ACCOUNT_DELETED })

      toast.success('Your account has been permanently deleted')
    } catch (err) {
      dispatch({
        type: PROFILE_TEACHER_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      })
    }
  }
}

// Get profile teacher by Id
export const getProfileTeacherById = (teacherId) => async (dispatch) => {
  try {
    const res = await api.get(`/profileTeacher/${teacherId}`)

    dispatch({ type: GET_PROFILE_TEACHER_BY_ID_SUCCESS, payload: res.data })
  } catch (err) {
    dispatch({
      type: GET_PROFILE_TEACHER_BY_ID_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

export const getTeachers = (page) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })

    const { data: { data, currentPage, numberOfPages } } = await api.get(`/teachers/english?page=${page}`)

    dispatch({ type: FETCH_ALL_TEACHERS, payload: { data, currentPage, numberOfPages } })
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error)
  }
}

export const getTeachersBySearch = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data: { data } } = await api.get(`/teachers/english/search?name=${searchQuery}`)

    dispatch({ type: FETCH_TEACHERS_BY_SEARCH, payload: { data } });
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error)
    dispatch({ type: FETCH_TEACHERS_BY_SEARCH_FAIL, payload: error })
    dispatch({ type: END_LOADING })
  }
}